import { Rule } from "antd/lib/form";

/**限制必填 */
export function getRequiredRule(message: string = "此项必须填写"): Rule {
  return {
    required: true,
    message,
  };
}

export function getPositiveNumberRule(message = "请输入一个大于0的数字"): Rule {
  return {
    validator(rule, value) {
      if (isNaN(value)) return Promise.reject(new Error(message));

      if (value <= 0) return Promise.reject(new Error(message));

      return Promise.resolve();
    },
  };
}

function getByteLength(val: string = "") {
  var len = 0;
  for (var i = 0; i < val.length; i++) {
    var a = val.charAt(i);
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
}

/**限制字符数 */
export function getLimitByteLengthRule(maxLength: number, message: string = `字数不能超过${maxLength}个字符`): Rule {
  return {
    validator(rule, value) {
      if (typeof value === "string") {
        const length = getByteLength(value);

        if (length > maxLength) {
          return Promise.reject(`${message}`);
        }
      }

      return Promise.resolve();
    },
  };
}

export function getRequiredRuleByArray(message: string = "此项必须至少选中一个"): Rule {
  return {
    validator(rule, value) {
      if (Array.isArray(value) && value.length) {
        return Promise.resolve();
      }

      return Promise.reject(message);
    },
  };
}

/* 模板检验 */
export function getTemplateNumberValidator(rule, value) {
  const { field } = rule;

  const prefix = field === "width" ? "模板宽度" : "模板高度";

  if (isNaN(value)) {
    return Promise.reject(`${prefix}必须是一个数字！`);
  }

  if (parseInt(value) < 10) {
    return Promise.reject(`${prefix}最小为10毫米`);
  }

  return Promise.resolve();
}

export function getMaxLimitRuleByArray(
  maxLimit: number = 20,
  message: string = `此项必须最多只能选中${maxLimit}个`
): Rule {
  return {
    validator(rule, value) {
      if (Array.isArray(value) && value.length <= maxLimit) {
        return Promise.resolve();
      }

      return Promise.reject(message);
    },
  };
}
